export default {
  spinner: {
    fontSize: '20px'
  }
}
